import { getSearch } from '@disco/state-management/selectors/shareable-channels'
import { parseSearchQuery } from '@disco/utils/string-utils'
import { createSelector } from 'reselect'
export {
  getSearch,
  getSearchState,
} from '@disco/state-management/selectors/shareable-channels'
export const getSearchQuery = (state: any): string | null | undefined => {
  const search = getSearch(state)
  return search ? search.query : null
}
export const getSearchTerms = createSelector(getSearchQuery, q =>
  parseSearchQuery(q),
)
export const getSearchNextUrl = (state: any): string | null | undefined => {
  const search = getSearch(state)
  return search ? search.next : null
}
